import ReactGA from 'react-ga4';
import Button from '../components/ui/Button';
import '../styles/pages/products.scss'
import { useState, useEffect } from 'react';
import axios from 'axios';
import FlowerTitle from '../components/ui/FlowerTitle';
import AltTitle from '../components/ui/AltTitle';


const Products = () => {

  const [platform, setPlatform] = useState("nsw2")
  const [region, setRegion] = useState('NA');

  return (
    <div className="page-container" style={{paddingTop: '100px'}}>
       <FlowerTitle text="Products"/>
       <h1 className="platform-header yellow-text"
        style={{
          filter: "drop-shadow(0px 0px 4px black) drop-shadow(0px 0px 2px black) drop-shadow(0px 0px 2px black)"
        }}
       >
        Please select a region:
       </h1>
       <div className="platform-list">
        <Button text="NA" size="smaller" color="blue" onClick={()=>{setRegion("NA")}}/>
        <Button text="EU" color="blue" onClick={()=>{setRegion("EU")}}/>
       </div>
       <h1 className="platform-header yellow-text"
        style={{
          filter: "drop-shadow(0px 0px 4px black) drop-shadow(0px 0px 2px black) drop-shadow(0px 0px 2px black)"
        }}
       >
        Please select a section:
       </h1>
       <div className="platform-list">
        <Button text="Nintendo Switch™2" size="smaller" color="red" onClick={()=>{setPlatform("nsw2")}}/>
        <Button text="Merchandise" color="yellow" onClick={()=>{setPlatform("merch")}}/>
       </div>
       <ProductSection region={region} platform={platform}/>
    </div>
  )
}

const ProductSection = ({platform, region}) => {  
  return (
    <div className="product-section">
      <AltTitle text={
        platform === "nsw2" ? "Nintendo Switch™2" : "Merchandise"
      }/>
      {
        platform === "nsw2" ? <NSWProducts region={region}/> : <Merchandise/>
      }
    </div>
  )
}

const NSWProducts = ({region}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    // Function to fetch data
    const fetchData = async () => {
      try {
        const response = await axios.get('https://nisamerica.com/api/game/disgaea-7-complete'); // Replace with your API endpoint
        setData(response.data.game.retailerLinks); // Update state with fetched data
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // Call the fetchData function
    fetchData();
  }, []); 

  
  return (
    <>
        <h1 className="edition-text yellow-text">
          Collector's Edition
        </h1>
      <div className="product-pair"
        style={{
          display: 'flex',
          flexDirection: 'column'
        }}
      >
          {
            <img src={`${process.env.PUBLIC_URL}/img/products/le-nsw2.jpg`} alt="" />
          }
          <div className="product-list">
            <a href="https://store.nisamerica.com/products/disgaea-7-complete-ewwdo-edition" target="_blank" rel="noopener noreferrer">
              <Button size="smaller" text="NISA Online Store" color="red" onClick={()=>{
                ReactGA.event({
                  category: 'Link',
                  action: 'Click',
                  label:  `NSW2 - LE - NISA ONLINE STORE`
                })
              }}/>
            </a>
          </div>
        </div>
        <h1 className="edition-text white-text">
          Deluxe Edition
        </h1>
        <div className="product-pair"
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {
              <img src={`${process.env.PUBLIC_URL}/img/products/de-nsw2.png`} alt="" />
          }
          <div className="product-list"
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              flexDirection: 'row',
              maxWidth: '1200px',
              justifyContent: 'center'
            }}
          >
                {
                data && data.map((product, index)=>(
                 product.region === region && product.edition === "Deluxe Edition" &&
                  <a href={`${product.url}`} target="_blank" rel="noopener noreferrer" style={{margin: "10px"}} key={index}>
                    <Button color="blue" text={product.store} onClick={()=>{
                      ReactGA.event({
                        category: `Product - Deluxe Ediiton - ${product.store} - ${product.platform}`,
                        action: `Product - Deluxe Ediiton - ${product.store} - ${product.platform}`,
                        label: `Product - Deluxe Ediiton - ${product.store} - ${product.platform}`,
                      });
                    }}/>
                  </a>
                ))
              }
          </div>
        </div>
    </>
  )
}

const Merchandise = () => (
  <>
      <h1 className="edition-text yellow-text">
        Netherworld Warriors Acrylic Print
      </h1>
      <div className="product-pair">
        <img src={`${process.env.PUBLIC_URL}/img/products/acrylic.jpg`} alt="" />
        <div className="product-list">
          <a href="https://store.nisamerica.com/disgaea-7-vows-of-the-virtueless/disgaea-7-vows-of-the-virtueless-netherworld-warriors-acrylic-print" target="_blank" rel="noopener noreferrer">
            <Button text="NISA Online Store" color="yellow" onClick={()=>{
              ReactGA.event({
                category: 'Link',
                action: 'Click',
                label:  `acrylic - Merch - NISA ONLINE STORE`
              })
            }}/>
          </a>
        </div>
      </div>
      <h1 className="edition-text white-text">
        Faces of Hinomoto Desk Mat
      </h1>
      <div className="product-pair">
        <img src={`${process.env.PUBLIC_URL}/img/products/deskmat.jpg`} alt="" />
        <div className="product-list">
          <a href="https://store.nisamerica.com/products/disgaea-7-vows-of-the-virtueless-faces-of-hinomoto-desk-mat" target="_blank" rel="noopener noreferrer">
            <Button text="NISA Online Store" color="yellow" onClick={()=>{
              ReactGA.event({
                category: 'Link',
                action: 'Click',
                label:  `Acryllic - Merch - NISA ONLINE STORE`
              })
            }}/>
          </a>
        </div>
      </div>
      <h1 className="edition-text white-text">
        Lil' Pirilika Plush
      </h1>
      <div className="product-pair">
        <img src={`${process.env.PUBLIC_URL}/img/products/pirilika.jpg`} alt="" />
        <div className="product-list">
          <a href="https://store.nisamerica.com/disgaea-7-vows-of-the-virtueless/disgaea-7-lil-pirilika-plush" target="_blank" rel="noopener noreferrer">
            <Button text="NISA Online Store" color="yellow" onClick={()=>{
              ReactGA.event({
                category: 'Link',
                action: 'Click',
                label:  `PirilikaPlush - Merch - NISA ONLINE STORE`
              })
            }}/>
          </a>
        </div>
      </div>
      <h1 className="edition-text white-text">
        Lil' Fuji Plush
      </h1>
      <div className="product-pair">
        <img src={`${process.env.PUBLIC_URL}/img/products/fuji.jpg`} alt="" />
        <div className="product-list">
          <a href="https://store.nisamerica.com/disgaea-7-vows-of-the-virtueless/disgaea-7-lil-fuji-plush" target="_blank" rel="noopener noreferrer">
            <Button text="NISA Online Store" color="yellow" onClick={()=>{
              ReactGA.event({
                category: 'Link',
                action: 'Click',
                label:  `FujiPlush - Merch - NISA ONLINE STORE`
              })
            }}/>
          </a>
        </div>
      </div>
  </> 
)


export default Products